import React from "react";
import infoCircle from "../../assets/info-circle.svg";

const PageGeneralDetails = ({ values, errors, touched, handleChange, handleBlur }) => (
  <div className="theme-card p-4 mb-3">
    <div className="card-title pb-3">General Details</div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        Page Title
        <img className="ms-2" src={infoCircle} alt="Info" title="Add title of Page" />
      </label>
      <input
        type="text"
        name="title"
        className="frm-input"
        placeholder="Enter page title eg. About Us"
        value={values.title}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.title && errors.title && <div className="input-error">{errors.title}</div>}
    </div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        Slug
        <img className="ms-2" src={infoCircle} alt="Info" title="Add slug of Page" />
      </label>
      <input
        type="text"
        name="slug"
        className="frm-input"
        placeholder="Slug name eg. about-us"
        value={values.slug}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.slug && errors.slug && <div className="input-error">{errors.slug}</div>}
    </div>
  </div>
);

export default PageGeneralDetails;
